import React, { useCallback, useMemo } from 'react';
import t from 'common/i18n';
import { ColorPalette } from '@cld/color-picker';
import { useFilterParams } from '../../selectors';
import { COLOR_OPTIONS } from '../../filterConsts';
import { SectionBox } from './Filters.styles';

export default ({ handleSearch, source }) => {
  const { color } = useFilterParams(source);
  const colorOptions = useMemo(() => {
    return COLOR_OPTIONS.find((c) => c === color) ? COLOR_OPTIONS : [...COLOR_OPTIONS, color];
  }, [color]);
  const filterChange = useCallback(
    (item) => {
      handleSearch({
        filters: {
          color: item[0],
        },
      });
    },
    [handleSearch]
  );
  return (
    <SectionBox data-test="color-section">
      <label>{t(`${source}.filters.colors.label`)}</label>
      <ColorPalette colors={colorOptions} selectedColors={[color]} onChange={filterChange} />
    </SectionBox>
  );
};
